import { useState } from 'react';

import Modal from '../../components/modal/modal.component';
import CustomInput from '../../components/custom-input/custom-input.component';
import { VehicleCreation } from '../../types/vehicle.type';
import { userSdk } from '../../services/user.service';
import { validateSchema } from '../../utils/validate-schema';
import {
    VehicleForm,
    vehicleFormSchema,
} from '../../validations/vehicle-form.schema';

import styles from './add-vehicle-modal.module.scss';

interface Props {
    userId: number;
    onConfirm: (vehicle: VehicleCreation) => void;
    onDiscard: () => void;
}

const AddVehicleModal = ({ userId, onConfirm, onDiscard }: Props) => {
    const [form, setForm] = useState<VehicleForm>({
        brand: '',
        model: '',
        color: '',
        plate: '',
        manufactureYear: '',
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const addFormField = (attr: string, value: string) => {
        setForm((prev) => ({ ...prev, [attr]: value }));
    };

    const onCreate = async () => {
        if (loading) return;

        setError('');
        const errors = validateSchema(form, vehicleFormSchema);
        if (errors) return setError([...errors.values()].join('. '));

        setLoading(true);
        try {
            const payload = vehicleFormSchema.cast(form);
            const response = await userSdk.addVehicle(userId, payload);

            if ('error' in response) return setError(response.error);

            onConfirm(payload);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            onConfirm={onCreate}
            onDiscard={onDiscard}
            confirmLoading={loading}
        >
            <div className={styles.modal}>
                <h4>Añadir nuevo vehículo</h4>
                <div className={styles.row}>
                    <div className={styles.inputWrapper}>
                        <label>Marca</label>
                        <CustomInput
                            type={'text'}
                            onChange={(brand) => addFormField('brand', brand)}
                        />
                    </div>
                    <div className={styles.inputWrapper}>
                        <label>Modelo</label>
                        <CustomInput
                            type={'text'}
                            onChange={(model) => addFormField('model', model)}
                        />
                    </div>
                </div>
                <div className={styles.row}>
                    <div className={styles.inputWrapper}>
                        <label>Color</label>
                        <CustomInput
                            type={'text'}
                            onChange={(color) => addFormField('color', color)}
                        />
                    </div>
                    <div className={styles.inputWrapper}>
                        <label>Placa</label>
                        <CustomInput
                            type={'text'}
                            max={7}
                            onChange={(plate) => addFormField('plate', plate)}
                        />
                    </div>
                </div>
                <div className={styles.row}>
                    <div className={styles.inputWrapper}>
                        <label>Año de fabricación</label>
                        <CustomInput
                            type={'number'}
                            onChange={(year) =>
                                addFormField('manufactureYear', year)
                            }
                        />
                    </div>
                </div>
                {error && <span className={styles.errorMessage}>{error}</span>}
            </div>
        </Modal>
    );
};

export default AddVehicleModal;
